import { AuthProviderV2 } from '@mit/aws-vue';
import { offlineAuthProvider } from './offlineAuthProvider';

/**
 * The single place the app resolves its auth provider.
 *
 * Everything that used to import `AuthProviderV2` from `@mit/aws-vue` now
 * imports `AuthProvider` from here. In every deployed stage that IS
 * `AuthProviderV2` — same object, no wrapper, no behaviour change. Only when
 * the app is built with VITE_OFFLINE_MODE=true does it become the local
 * fixture provider, which mints a JWT instead of talking to Okta.
 *
 * Keeping the choice here (rather than a Vite alias or a build-time swap) means
 * it is greppable, type-checked, and obvious to the next person reading
 * App.vue why sign-in behaves differently on a laptop with no network.
 */
export const IS_OFFLINE = import.meta.env.VITE_OFFLINE_MODE === 'true';

type AuthProviderShape = Pick<
  typeof AuthProviderV2,
  'configure' | 'getState' | 'isAuthenticated' | 'signIn' | 'getToken'
>;

export const AuthProvider: AuthProviderShape = (
  IS_OFFLINE ? offlineAuthProvider : AuthProviderV2
) as AuthProviderShape;

if (IS_OFFLINE) {
  console.info(
    '%c OFFLINE MODE ',
    'background:#a31f34;color:#fff;font-weight:600;border-radius:3px',
    'Auth is a local fixture. No request leaves this machine.'
  );
}
